import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Attendance (Trainee) ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row p-4" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Association", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Course", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Batches", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "col-md-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch Term", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-10" }, "Trainee Detail by Poverty", -1)
const _hoisted_28 = { class: "card mb-5 mb-xl-10" }
const _hoisted_29 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_30 = { class: "row mt-1 w-100 m-0" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "div pb-2" }
const _hoisted_33 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  id: "trainee_data",
  class: "collapse show"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "collapse show" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body border-top p-6" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "current",
        "data-kt-stepper-element": "content"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "table-responsive mt-3" }, [
          /*#__PURE__*/_createElementVNode("table", { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }, [
            /*#__PURE__*/_createElementVNode("thead", null, [
              /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  colspan: "40"
                }, " Filtering Options=> Start Date = 2022-02-08 && End Date = 2022-02-17 && Association = [AEOSIB]-Association of Export Oriented Shipbuilding Industries of Bangladesh && Institute = Centre For Vocational Training && Course = SEIP-AEOSIB-S.Piping-T2 | Ship Piping | 3 | 360 | 36982.45 && Batch = 2 ")
              ]),
              /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Sl "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Association "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " TI "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Course "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Training Type "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Course Month "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Batch "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Start Date "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " End Date "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Duration "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Reg # "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Name "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Father "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Mother "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Gender "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Mobile "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Bank "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Branch "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Ethnic Minority "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Account Number "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Physically Challenged "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Income "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Address "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Postcode "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Upazilla "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Home District "),
                /*#__PURE__*/_createElementVNode("th", {
                  class: "w-25px text-center align-middle border border-gray-400",
                  rowspan: "2"
                }, " Attendance (%) ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      modelValue: _ctx.batch.association_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.association_name) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Institute",
                      modelValue: _ctx.batch.institute_name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_name) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Course",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "PHP",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PHP")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Graphics Design",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Graphics Design")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Courses",
                      modelValue: _ctx.batch.course_batch,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.course_batch) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.entity_short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.entity_short_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _hoisted_25,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Batch",
                      modelValue: _ctx.batch.batch_term,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_term) = $event)),
                      filterable: "",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.courseNotice())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control ps-10 w-200px mt-1 form-control-sm",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
                                onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchItems())),
                                style: {"height":"1em"},
                                placeholder: "Search"
                              }, null, 544), [
                                [_vModelText, _ctx.search]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_35),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_37),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_39)
                          ])
                        ])
                      ]),
                      _hoisted_40
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}